// 騎士の予告音 (構えの音) の候補 (2026-09-29・ユーザー「騎士の予告音をこの手順で作ってみて」)。
//   溜めの頭で「何が来るか」を言う。弾く技 (境界の薙ぎ・薙ぎ下がり) と見切る技 (宣告の突き) で別の音。
//   a 兜の息 / b 掛け声 / c 鎧と槍 (声なし)。now = 全ボス共通の唸り (telegraph_growl) のまま = 既定・配布版と同じ。
//   音の書き出し = scripts/render_knight_telegraph_sound.py → public/sfx/candidates/ (git 外)。
//   発注票と意図 = docs/departments/sound/2026-09-29-knight-telegraph-sound.md。
import type { SfxId } from './types'

export const KNIGHT_TELL_CANDIDATES = ['a', 'b', 'c'] as const
export type KnightTellSound = 'now' | typeof KNIGHT_TELL_CANDIDATES[number]
export const KNIGHT_TELL_SOUNDS: readonly KnightTellSound[] = ['now', ...KNIGHT_TELL_CANDIDATES]
export const KNIGHT_TELL_SFX_IDS = KNIGHT_TELL_CANDIDATES.flatMap(k => [`knight_tell_${k}_parry`, `knight_tell_${k}_mikiri`] as const)

let knightTellSound: KnightTellSound = 'now'
export function getKnightTellSound(): KnightTellSound { return knightTellSound }
export function setKnightTellSound(v: KnightTellSound): void { knightTellSound = v }
export function parseKnightTellSound(v: string | null): KnightTellSound | null {
  return v && (KNIGHT_TELL_SOUNDS as readonly string[]).includes(v) ? v as KnightTellSound : null
}

// 騎士の溜めの頭に、共通の唸りの代わりに鳴らす音。null = 共通の唸りのまま。
export function knightTellSfx(attackId: string): SfxId | null {
  if (knightTellSound === 'now') return null
  if (attackId === 'lanceSweep' || attackId === 'lanceCross' || attackId === 'lanceShove') return `knight_tell_${knightTellSound}_parry`
  if (attackId === 'lanceThrust') return `knight_tell_${knightTellSound}_mikiri`
  return null
}
